import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import type React from "react";
import styled from "styled-components";

const FieldWrapper = styled.div`
  margin-bottom: 24px;
  text-align: left;
`;

const LabelRow = styled.label`
  display: inline-flex !important;
  flex-direction: row !important;
  align-items: center;
  gap: 4px;
  margin-bottom: 6px;
  font-weight: 700;
  font-size: 16px;
  cursor: text;
  text-align: left;
`;

const RequiredMark = styled.span`
  color: #d32f2f;
`;

const StyledInput = styled.input`
  width: 100%;
  margin-top: 6px;
  font-size: 16px;
  border-radius: 6px;
  padding: 10px 12px;
  border: 1px solid var(--color-primary-desat);
  transition: all 0.25s;

  &:focus,
  &:active,
  &:focus-visible {
    border: 1px solid var(--color-primary-dark) !important;
    outline: none;
  }
`;

export interface TextFieldProps {
  label: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  tooltip?: string;
  readOnly?: boolean;
}

const StyledInputReadOnly = styled(StyledInput)`
  background-color: rgba(0, 0, 0, 0.04);
  cursor: not-allowed;
`;

const TextField: React.FC<TextFieldProps> = ({
  label,
  name,
  value,
  onChange,
  required = false,
  tooltip,
  readOnly = false,
}) => {
  const InputComponent = readOnly ? StyledInputReadOnly : StyledInput;
  return (
    <FieldWrapper>
      <LabelRow htmlFor={name}>
        {label}
        {required && <RequiredMark>*</RequiredMark>}
        {tooltip && (
          <Tooltip title={tooltip}>
            <span style={{ display: "inline-flex", cursor: "help" }}>
              <FontAwesomeIcon
                icon={faCircleInfo}
                style={{
                  color: "var(--color-primary-desat)",
                  fontSize: "0.9rem",
                }}
              />
            </span>
          </Tooltip>
        )}
      </LabelRow>
      <InputComponent
        id={name}
        type="text"
        value={value}
        onChange={(e) => !readOnly && onChange(e.target.value)}
        aria-required={required}
        readOnly={readOnly}
        disabled={readOnly}
      />
    </FieldWrapper>
  );
};

export default TextField;
